import { render, staticRenderFns } from "./houseRent.vue?vue&type=template&id=440a5f71&scoped=true"
import script from "./houseRent.vue?vue&type=script&lang=js"
export * from "./houseRent.vue?vue&type=script&lang=js"
import style0 from "./houseRent.vue?vue&type=style&index=0&id=440a5f71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a5f71",
  null
  
)

export default component.exports